export default {
  $vuetify: {
    badge: 'バッジ',
    close: '閉じる',
    dataIterator: {
      noResultsText: '該当するレコードはありません。',
      loadingText: '読み込み中のアイテム...',
    },
    dataTable: {
      itemsPerPageText: 'ページあたりの行数',
      ariaLabel: {
        sortDescending: 'ソートされた降順。',
        sortAscending: '昇順でソートされています。',
        sortNone: 'ソートされていない。',
        activateNone: 'アクティブにすると、ソートが解除されます。',
        activateDescending: '有効にすると、降順でソートされます。',
        activateAscending: '有効にすると、昇順にソートされます。',
      },
      sortBy: '並び替え',
    },
    dataFooter: {
      itemsPerPageText: '1ページあたりのアイテム数',
      itemsPerPageAll: 'すべて',
      nextPage: '次のページ',
      prevPage: '前のページ',
      firstPage: '最初のページ',
      lastPage: '最終ページ',
      pageText: '{0}-{1} の {2}',
    },
    datePicker: {
      itemsSelected: '{0} セレクト',
      nextMonthAriaLabel: '来月',
      nextYearAriaLabel: '来年',
      prevMonthAriaLabel: '前月',
      prevYearAriaLabel: '前年度',
    },
    noDataText: 'データがありません',
    carousel: {
      prev: '前回のビジュアル',
      next: '次のビジュアル',
      ariaLabel: {
        delimiter: 'カルーセル・スライド {0} の {1}',
      },
    },
    calendar: {
      moreEvents: '他 {0}',
    },
    fileInput: {
      counter: '{0} ファイル',
      counterSize: '{0} ファイル ({1} 合わせて)',
    },
    timePicker: {
      am: '午前',
      pm: '午後',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'ページネーション・ナビゲーション',
        next: '次のページ',
        previous: '前のページ',
        page: 'ページに戻る {0}',
        currentPage: '現在のページ、ページ {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: '評価 {0} の {1}',
      },
    }
  },
  common: {
    loading: '積載...',
    maximum_text: 'このフィールドは{length}文字以下でなければなりません。',
    activation: '映像コンテンツ利用可能アカウント',
    action: '詳細',
    email_invalid: 'メールが無効です。',
    timezone: 'タイムゾーン',
    edit: '編集',
    confirm: '有効にする',
    confirmation: '確認',
    reject: '拒否する',
    draft: 'ドラフト',
    save: '保存',
    cancel: 'キャンセル',
    search: '検索',
    require: '必須項目です。',
    required: '必須',
    invalid: '無効',
    invalid_file_format: '無効なファイルフォーマット',
    auth_error: 'IDもしくはパスワードが間違っているようです。もう一度入力してください。',
    no_role_error: 'システムを使用するには、会社の認定トレーナーまたはセールスパーソンである必要があります。 情報を更新するには、システム部門に連絡してください',
    unknown_error: '不明なエラーが発生しました。 info@achievement.co.jpまでご連絡ください',
    network_not_reach_error: '申し訳ありませんが、リクエストまたは接続で問題が発生しました',
    network_backend_error: '申し訳ありませんが、リクエストに問題があり、サーバーが正しく機能しません。 もう一度やり直してください。',
    network_backend_duplicate_error: '資源競合',
    network_generic_error: 'エラーメッセージ：{msg}',
    network_not_found_error: '開こうとした予約は何らかの変更がされていて開くことが出来ません',
    network_not_allow: '認証プロセスで問題が発生しました。カスタマーサービスまで連絡をお願いします。',
    network_unprocessable: '申し訳ありませんが、指定された入力は無効です。（{msg}）',
    validate_dob_year: '有効な年の形式ではありません',
    validate_dob_month: '月は1〜12の間で入力してください',
    validate_dob_day: '日は1〜31の間で入力してください',
    close: '閉じる',
    page_denied_title: 'アクセス権限がありません',
    page_denied_desc: 'このページにアクセスする権限がありません。管理者に{pageName}ページを{groupName}グループに割り当てるようにご依頼してください。',
    phone_invalid: '電話番号が無効です。',
    dob_invalid: '生年月日が無効です。',
    pre_course_report: '受講前レポート',
    post_course_report: '受講後レポート',
    pre_course: '受講前',
    post_course: '受講後'
  },
  employee: {
    apply: '申請',
    unassigned: '無記名',
    click_to_disable: 'クリックすると無効化されます',
    click_to_enable: 'クリックすると有効になります',
    not_in_group: 'ログインを許可するためには、社員がいずれかのユーザーグループに属している必要があります。',
    user_group: 'QUATS権限グループ',
    is_can_login: 'ログイン許可',
    permission_group_assignment: '権限グループの割り当て',
    no_csv: 'CSVファイルを選択してください',
    name: '社員名',
    name_kana: '社員名 (フリガナ)',
    id: 'ID',
    disclosure_level: '情報開示レベル',
    title: '映像コンテンツの視聴設定',
    create_employee: '社員のMARCアカウントを作成する',
    surname: '姓',
    firstname: '名',
    surname_kana: '姓（カナ）',
    firstname_kana: '名（カナ）',
    dob: '生年月日',
    dob_title: '生年月日',
    dob_year: '年',
    dob_month: '月',
    dob_day: '日',
    sex: '性別',
    mail_address: 'メールアドレス',
    phone_number: '電話番号',
    visible_teaching_material: '設定済み映像コンテンツ',
    action: '視聴権の付与',
    pagination_text: 'ページ当たりの社員表示人数',
    create_with_csv: '複数名のアカウントの一括作成（csvアップロード）はこちら',
    create_with_csv_shortened: '一括作成（csvアップロード）はこちら',
    active: '有効',
    enable: '有効にする',
    detail: '編集',
    search_success_message: 'データが正常にロードされました',
    csv_title: 'のデータは、以下の通りです',
    csv_title_valid: '社のデータは、以下の通りです',
    csv_title_invalid: 'のヘッダーが一致しない',
    upload_csv: 'CSVのアップロードはこちら',
    csv_no_data: 'のデータがありません。',
    download_template: 'テンプレートファイルをダウンロードして、ファイルを取り込んでください',
    individual_creation: '個別で作成はこちら',
    download: 'テンプレートダウンロード',
    change_viewing_right_title: 'プログラム視聴権変更',
    corporate_activated: 'アカウントは正常に有効化されました。',
    corporate_deactivated: 'アカウントは正常に無効化されました。',
    phone_3_digits: '入力は正数で、3文字以内でお願いします',
    phone_4_digits: '入力は正数で、4文字以内でお願いします',
    email_rule: 'メールアドレスの形式が間違っています',
    customer_id: 'お客様ID',
    download_award: '『人が育つ仕組み』のつくり方 人事制度の設計と運用 -基礎編-資料ダウンロード',
    login_toggle_success: '権限グループの更新に成功しました。',
    activate_login: 'ログインアカウントは正常に有効化されました。',
    deactivate_login: 'ログインアカウントは正常に無効化されました。',
    note: '※アチーブメントのMARCアカウントをお持ちでない方は、「MARCアカウントの作成」→「QUATSとの連携」を頂くことで、本ページ（映像コンテンツの視聴設定）のリストに名前が出ます。\n' +
      '※アチーブメントテクノロジーコースをお申込済みの方は既にMARCアカウントをお持ちです。\n' +
      '※当該社員がMARCアカウントをお持ちか分からない場合は、「MARCアカウントの作成」ボタンからお進みください。',
    create_employee_marc_account: '社員のMARCアカウントを作成',
    dialog_note: '※本申請後、２営業日を目安にMARCアカウントを発行し、社員のメールアドレスにMARCのIDとパスワードを送信します。社員様にMARCにログインいただいた後、ユーザー情報変更画面から情報開示ボタンを押していただき次第、QUATSの社員リストに追加されます。'
  },
  detail: {
    fullName: '氏名',
    employee_info: '従業員情報',
    company_info: '会社情報',
    company_name: '会社名',
    max_corporate: '最大公約数',
    available_corporate: '映像コンテンツ利用可能アカウント残数',
    name: '映像コンテンツ名',
    parent_company_program: '利用可能な映像コンテンツ一覧',
    active: '有効',
    enable: 'イネーブル',
    max_view: '利用可能最大数',
    available: '視聴権残数',
    can_view: 'プログラムの利用を開始する',
    warning: 'プログラムを有効にすると無効にする事が出来ません。',
    no_available_corporate: '利用可能なアカウントは残っていません'
  },
  navigation_list: {
    home_page: 'ホーム',
    employee: '映像コンテンツの視聴設定',
    employee_seminar_info: '社員受講履歴',
    manual: 'ユーザーマニュアル',
    user_group: 'QUATS権限グループの設定',
    login_account: 'QUATS権限グループの割り当て',
    back: '前へ',
    course_report: '社員受講レポート設定'
  },
  login: {
    what_is_quats: '法人会員サイト〔QUATS〕とは？',
    quats_desc_1: 'QUATSとはQuality Company Training Management Systemの略で、企業内での社員育成の支援を目的とした、アチーブメント会員限定のインターネットサービスです。',
    quats_desc_2: 'QUATSはクオリティカンパニー倶楽部の方のためのサービスになります。',
    marc_desc_3: 'MARCはクラブ会員・JPSA会員の方のためのサービスになります。',
    detail: '詳しくはこちら',
    privacy_policy: 'プライバシーポリシー',
    quats_id: 'QUATS IDまたはメールアドレス',
    quats_id_required: 'QUATS IDまたはメールアドレスを入力してください',
    quats_id_invalid: 'QUATS IDまたはメールアドレスが無効です',
    password: 'パスワード',
    password_required: 'パスワードを入力してください',
    forget_password: 'パスワードをお忘れの方',
    password_reset: 'パスワードリセット',
    password_reset_instruction_1: 'QUATS IDまたはメールアドレスを入力し、',
    password_reset_instruction_2: '「リセットする」ボタンをクリックしてください。',
    reset: 'リセットする',
    back_to_login: 'ログインページに戻る',
    login: 'ログイン',
    to_marc: '個人会員サイトはこちら',
    credential_not_match: '認証情報が一致しない',
    must_be_person: '人型であること',
    new_password: '新しいパスワード',
    confirm_new_password: '新しいパスワードの確認',
    new_password_instruction_1: '新しいパスワード、新しいパスワードの確認をご記入の上、',
    new_password_instruction_2: '「新しいパスワードを設定する」ボタンをクリックしてください。',
    new_password_required: '新しいパスワードを入力してください',
    confirm_new_password_required: '新しいパスワードの確認を入力してください',
    set_new_password: '新しいパスワードを設定する',
    must_be_numeric: 'QUATS IDは数字で入力してください',
    password_not_match: 'パスワードが一致しません',
    reset_link_sent: 'リセットリンクが送信されました。',
    reset_info: 'パスワードをリセットするためのリンクがメールに送信されました。メールの受信箱をご確認の上、リンクをクリックして新しいパスワードの設定にお進みください。',
    successfully_reset: 'パスワードのリセットに成功しました。ログインページに戻ります。',
    minimum_six: 'パスワードは6文字以上でなければなりません',
    login_via_marc: 'MARCアカウントでログイン',
    or: 'または'
  },
  error_message: {
    not_found: 'このIDを持つユーザーは存在しない',
    something_went_wrong: '何か問題が発生しました。もう一度やり直してください'
  },
  homepage: {
    corporate_content: '企業情報',
    member_company_information: '会員企業情報',
    company_name: '企業名',
    enterprise_id: '企業ID',
    membership_status: '会員ステータス',
    membership_status_change: '会員ステータス変更について',
    employee_registration_status: '映像コンテンツ利用可能アカウント残数',
    for_first_time_customer: '初めてログインする方へ',
    register_employee: '映像コンテンツの視聴設定をする',
    quat_user_guide: 'QUATSの操作マニュアル（必読）',
    membership_start_date: '会員開始日',
    membership_end_date: '会員終了日',
    membership_renewal_date: '会員更新日',
    update_membership: '会員の更新',
    change_membership_category: '会員ステータスの変更',
    update_description: '〜説明文〜',
    current_membership_category: '現在の会員区分',
    increase_employee: '社員の登録人数を増やしたい',
    upgrade_membership: '会員区分をアップグレードしたい',
    upgrade_membership_button: 'アップグレード',
    reduce_employee: '社員の登録人数を減らしたい',
    reduce_employee_form: '社員の登録人数を減ら',
    downgrade_membership: '会員区分をダウングレードしたい',
    downgrade_membership_form: '会員ステータスをダウングレードする',
    suspend_membership: '休会したい',
    suspend_membership_form: '会員ステータスを休会に変更',
    cancel_membership: '退会したい',
    cancel_membership_form: '会員ステータスを退会に変更',
    remark: '備考:',
    choose_new_membership_plan: '新しい会員プランをお選びください:',
    choose: '選ぶ',
    optional: '任意',
    back: '戻る',
    close: '閉じる',
    submit: '送信',
    warning: '注意',
    upgrade_membership_category: 'アップグレードについて',
    upgrade_membership_category_subtitle: '現在の会員区分をアップグレードすることができます。',
    upgrade_membership_category_heading_1: 'スターター会員→スタンダード会員',
    upgrade_membership_category_heading_1_content_1: 'お手続きの当日もしくは翌月より、会員区分をスタンダード会員へアップグレードすることができます。',
    upgrade_membership_category_heading_1_content_2: 'スターター会員の会員満了までの期間に応じた月割会費は他の商品・サービスへ充当もしくはご返金が可能です。',
    upgrade_membership_category_heading_1_content_3: 'スタンダード会員の特典についてはQCC公式ホームページにてご確認いただけます。',
    upgrade_membership_category_heading_2: 'スタンダード会員→スタンダード会員（アカウント増）',
    upgrade_membership_category_heading_2_content_1: 'お手続きの当月もしくは翌月より、オンライントレーニングプログラムの視聴アカウント数を増やすことができます。',
    upgrade_membership_category_heading_2_content_2: '現在の会員満了までの期間に応じた月割会費は他の商品・サービスへ充当もしくはご返金が可能です。',
    upgrade_membership_category_action_btn: 'アップグレード申込手続きに進む',
    upgrade_membership_category_contact_us_msg: 'アップグレードに関するお問い合わせやご相談はこちら',
    downgrade_suspension_withdrawal_membership: 'ダウングレード・休会・退会',
    downgrade_suspension_withdrawal_membership_category: 'ダウングレード・休会・退会について',
    downgrade_suspension_withdrawal_membership_category_subtitle_1: '会員有効期間最終月の前月10日までに所定のお手続きをいただくと、現在の会員有効期間が満期を迎えるタイミングで新しい区分へ変更となります。',
    downgrade_suspension_withdrawal_membership_category_subtitle_2: '上記を過ぎてからお手続きされた場合は、翌年の会員有効期間が満期を迎えるタイミングでの変更となります。',
    downgrade_suspension_withdrawal_membership_category_subtitle_3: 'ダウングレード・休会・退会をご検討の場合には、日数に余裕をもってお問合せいただけますようお願いいたします。',
    downgrade_suspension_withdrawal_membership_heading_1: 'ダウングレード',
    downgrade_suspension_withdrawal_membership_heading_1_content_1: 'オンライントレーニングプログラムの視聴アカウント数を減らす、もしくはスターター会員へ変更することができます。',
    downgrade_suspension_withdrawal_membership_heading_2: '休会',
    downgrade_suspension_withdrawal_membership_heading_2_content_1: '一時的に会員サービスを休止することができます。（休会費：年13,200円(税込)）',
    downgrade_suspension_withdrawal_membership_heading_2_content_2: '休会からスターター会員またはスタンダード会員に再変更をされた場合、休会前に購入したオンライントレーニングプログラムについては、休会前と同様にご利用いただくことが可能です。',
    downgrade_suspension_withdrawal_membership_heading_2_content_3: '休止中は基本的に会員サービス全般をお使いいただけなくなりますが、会報誌「QCCニュースレター」は定期送付いたします。',
    downgrade_suspension_withdrawal_membership_heading_3: '退会',
    downgrade_suspension_withdrawal_membership_heading_3_content_1: '会員サービスを退会することができます。',
    downgrade_suspension_withdrawal_membership_heading_3_content_2: '一度退会された後に、改めてスターター会員又はスタンダード会員に入会された場合、全てのオンライントレーニングプログラムは定価で再度ご購入いただく必要がございます。購入いただいたオンライントレーニングプログラムを今後もご利用の可能性がある場合は休会を推奨いたします。',
    downgrade_suspension_withdrawal_membership_contact_us_msg: '会員区分変更のご希望やご相談はこちら'
  },
  program_list_table: {
    available_list: '利用可能な映像コンテンツ一覧',
    video_content_name: '映像コンテンツ名',
    total_view: '利用可能最大視聴権数',
    assigned_view: '設定済み視聴権数',
    remaining_view: '視聴権残数'
  },
  group: {
    title: 'QUATS権限グループの設定',
    user_group_name: '権限グループ名',
    user_group_name_english: 'ユーザーグループ名 英語',
    user_group_description: '権限グループの説明 (そのグループがどの機能を利用できるかについて)',
    user_group_description_english: 'ユーザーグループの説明 英語',
    page_group_name: 'ページグループ名',
    page_group_description: 'ページグループの説明',
    page_group_listing: '{name}（ID: {id}）のページグループリスト',
    create_user_group: 'オリジナルの権限グループの作成',
    create: '作成',
    user_group_create_success: '権限グループの作成に成功',
    assign_module: '権限グループ「{name}」(ID: {id}) がアクセスできるページ',
    assign_module_to_user_group: '権限グループの編集',
    assign: '編集',
    group_information: 'グループ情報',
    user_group_page_updated_success: 'ページグループを更新しました。',
    unchangeable: '変更不可',
    note: 'このページでは、QUATSの権限グループの設定が行えます。\n' +
      'それぞれの権限ごとに、QUATS上での「映像コンテンツの視聴設定」「社員受講レポートの閲覧設定」などの閲覧・編集範囲を設定できます。\n' +
      '・初期設定は「管理者」「上長」「人事」の権限グループです。\n' +
      '・なお、誰をどの権限グループにするかは、「QUATS権限グループの割り当て」ページで設定が可能です。'
  },
  login_account: {
    title: 'QUATS権限グループの割り当て',
    assign_user_to_group: '権限グループの割り当て',
    assign_user_to_group_success: 'グループへのユーザー割り当てに成功',
    desc_1: '管理権限を持つ社員は、ユーザーグループを設定し、ログインを許可することで、MARCアカウントでQUATSにログインすることができるようになります。',
    desc_2: 'ログイン画面で、「MARCアカウントでログイン」ボタンをクリックしてログインしてください。',
    pagination_text: 'ページ当たりの社員表示人数'
  },
  employee_seminar_info: {
    title: '社員受講履歴',
    name: '社員名',
    name_kana: '社員名 (フリガナ)',
    atc: 'アチーブメントテクノロジーコース (ATC)',
    re_atc: 'アチーブメントテクノロジーコース再受講 (ATC再受講)',
    dc: 'ダイナミックコース (DC)',
    dac: 'ダイナミックアドバンスコース (DAC)',
    ppc: 'ピークパフォーマンスコース (PPC)',
    ptp: 'プロスピーカー・トレーニング・プログラム (PTP)',
    atc_re: 'アチーブメントテクノロジーコース (第{num}再受講)',
    customer_id: 'お客様ID',
    tab_road_top: '『頂点への道』シリーズ',
    tab_quality_company: 'クオリティカンパニーシリーズ',
    pagination_text: 'ページ当たりの社員表示人数',
    note: '※赤字の日程は受講予定の日程です。\n' +
      '※日程の隣の数字は、受講回数です。\n' +
      '※社員名をクリックすると受講履歴の詳細を閲覧頂けます。\n' +
      '※『頂点への道』シリーズについて、9/29までに社員登録された方は、10月末以降に表示予定です。\n' +
      '※『クオリティカンパニーシリーズ』について、システム上で企業登録が完了した日以降の履歴が表示されます。\n' +
      '※名前の横に（）が付いている社員の方はプロスピーカーになります。\n' +
      'APS＝アソシエイトプロスピーカー\n' +
      'BPS＝ベーシックプロスピーカー\n' +
      'SPS＝シニアプロスピーカー\n' +
      'EPS＝エグゼクティブプロスピーカー\n' +
      'MPS＝マスタープロスピーカー'
  },
  employee_seminar_detail: {
    first_attend: '初受講',
    reattended: '再受講{index}回目',
    attended: '受講済み',
    attendance_info: {
      title: 'セミナー受講情報',
      road_to_top_attendance_status: '『頂点への道』シリーズ受講状況',
      course_name_header: 'コース名',
      attendance_status_header: '受講状態',
      standard_atc_attendance_status: 'スタンダードコース／アチーブメントテクノロジーコース 受講状況',
      standard_atc_attendances_header: '受講回数'
    },
    course_report: '受講レポート',
    attendance_status_note: '※一部2005/10以前の受講状況情報はご確認いただけないことがあります。ご了承ください。',
    attendance_history: {
      title: 'セミナー受講履歴（『頂点への道』シリーズ以外）',
      schedule_header: '日程',
      venue_header: '開催地',
      seminar_name_header: 'セミナー名'
    },
    assistant_history: {
      title: 'アシスタント履歴',
      situation_header: '状況'
    }
  },
  course_report: {
    title: '社員受講レポート設定',
    pdf_download: 'PDF出力',
    reattended: '【再受講{index}回目】',
    first_attend: '【初受講】',
    seminar_date: '開催日：',
    seminar_information: 'セミナー情報',
    question: '問',
    fix_question: '固定の質問',
    required: '必須',
    custom_question: '問{number}を追加したい場合は質問内容を設定してください',
    date_of_attendance: '受講日',
    submitted: '提出済',
    not_submitted: '未提出',
    send_mail: 'メールを送る',
    original_question: 'オリジナルの質問',
    send_confirmation: 'リマインダーメールを送信してもよろしいですか？',
    send_success_message: 'メールが送信されました。',
    no_employee_text: '受講予定社員はいません',
    page_intro: '社員の受講レポートに関する設定画面です。',
    page_instruction: '▼ 本画面でできること\n' +
      '          <p>「レポート機能ON/OFFの設定」・「質問内容の編集」・「提出状況の確認」・「未提出者へのリマインドメール送信」が可能です。</p>\n' +
      '          ※レポート内容の確認方法\n' +
      '          <p>「左上のハンバーガーメニュー（三）」→「社員受講履歴」→「『頂点への道』シリーズ」→該当社員の「レポート」ボタンよりご確認いただけます。</p>',
    attendee_table_note: '※リストの表示期間は、セミナー受講日の前後1か月です<br>\n' +
      '※受講レポート機能を「OFF」に設定している場合、受講レポート機能はご利用いただけません'
  }
}
